// Banner Images

const equalCarouselSlideHeights = (): void => {
  const carousels = document.querySelectorAll<HTMLElement>(
    '.blog-posts-carousel .carousel'
  );

  const setCarouselHeight = (carousel: HTMLElement): void => {
    const slideHeights: number[] = [];
    const slides = carousel.querySelectorAll('.carousel-item');
    slides.forEach((slide: HTMLElement) => {
      slide.removeAttribute('style');
      slide.style.display = 'block';
      const slideContent = slide.querySelector('.carousel__slide');
      const slideHeight: number = slideContent.getBoundingClientRect().height;
      slideHeights.push(slideHeight);
      slide.removeAttribute('style');
    });
    const carouselHeight = Math.max(...slideHeights);
    slides.forEach((slide: HTMLElement) => {
      slide.style.height = carouselHeight + 'px';
    });
    // console.log(slideHeights);
  };

  carousels.forEach((carousel: HTMLElement) => {
    setCarouselHeight(carousel);
  });

  addEventListener('resize', () => {
    carousels.forEach((carousel) => {
      setCarouselHeight(carousel);
    });
  });
};

export default equalCarouselSlideHeights;
